import React from "react";

export const LoginTabIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="11" r="3.25" stroke="#020305" strokeWidth="1.5" />
      <path
        d="M6.5 19.318C7.84208 18.0095 9.50575 17 12 17C14.4943 17 16.1579 18.0095 17.5 19.318"
        stroke="#020305"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="9"
        stroke="#020305"
        strokeWidth="1.5"
      />
    </svg>
  );
};
